const RANKING_ITEMS = [
  { rank: 1, title: '某顶流男星深夜约会神秘女子，两人牵手画面曝光引热议', hot: '98.7万', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '热门综艺录制现场突发状况，导演组紧急叫停引发猜测', hot: '86.2万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '知名女星离婚内幕再添实锤，前夫发长文控诉引全网围观', hot: '73.5万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 4, title: '新晋流量小生片场耍大牌？知情人士爆料剧组真实情况', hot: '61.8万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '当红歌手被曝隐婚三年，配偶身份曝光后粉丝集体破防', hot: '55.3万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 6, title: '年度最具争议综艺节目排名出炉，榜首引发全网二刷讨论', hot: '42.1万', tag: '', tagColor: '' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            实时热度
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热度榜单</h2>
          <p className="text-sm text-foreground-500 mt-2">24小时最热吃瓜话题排行</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {RANKING_ITEMS.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-200/50 ${
                i < RANKING_ITEMS.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <span
                className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed truncate">
                  {item.title}
                </p>
              </div>
              {item.tag && (
                <span className={`shrink-0 px-2 py-0.5 rounded text-xs font-medium text-background-50 ${item.tagColor}`}>
                  {item.tag}
                </span>
              )}
              <span className="shrink-0 text-xs text-foreground-400 font-mono w-14 text-right">
                {item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}